import React, { useEffect, useState } from 'react';
import { View, Text } from 'react-native';

import api from '@common/configs/api';
import Loading from '@common/components/Loading';
import ShareScreen from '../ShareScreen';
import Render from '.';

enum APP_VERSION {
  V2 = 'v2',
  V3 = 'v3',
  V4 = 'v4',
}

export default function Home() {
  const [appId, setAppId] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(true);
  const [appVersion, setAppVersion] = useState<APP_VERSION | null>(null);

  const getURL = window.location.host;

  // MIK-4799: retry the domain lookup instead of stranding the user on
  // "Cannot found page" after one transient failure.
  const MAX_ATTEMPTS = 3;
  const RETRY_DELAY_MS = 800;
  const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

  useEffect(() => {
    let cancelled = false;

    (async () => {
      for (let attempt = 1; attempt <= MAX_ATTEMPTS; attempt++) {
        try {
          const resp: any = await api({
            method: 'get',
            url: `v2/apps-domain/${getURL}`,
          });

          if (cancelled) return;

          console.log('resp :>> ', resp);
          localStorage.setItem('appId', resp.data?.appId);

          setLoading(false);
          setAppId(resp.data?.appId);
          setAppVersion(resp.data?.version);
          return;
        } catch (error) {
          console.log(`error (attempt ${attempt}/${MAX_ATTEMPTS}) :>> `, error);
          if (cancelled) return;
          if (attempt < MAX_ATTEMPTS) {
            await sleep(RETRY_DELAY_MS * attempt);
            continue;
          }
          setLoading(false);
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, []);

  if (loading) return <Loading />;

  if (!appId) {
    return (
      <View>
        <Text>Cannot found page</Text>
      </View>
    );
  }
  console.log('appVersion :>> ', appVersion);

  if (appVersion && [APP_VERSION.V3, APP_VERSION.V4].includes(appVersion)) {
    return <Render appId={appId} />;
  }
  return <ShareScreen appId={appId} />;
}
